/// <reference path="../../dts/declaration.d.ts" />
/// <reference path="../../dts/interfaces.d.ts" />

import 'component/recaptcha.js';
import 'component/site.js';
import 'component/c001.js';
// import 'component/c002-basic.js';
import 'component/c002.js';
import 'component/c003-langSelector.js';
import 'component/c004.js';
import 'component/c004-searchheaderform.js';
import 'component/c005-bookingform.js';
import 'component/c005-checkin.js';
import 'component/c005-flightstatus-page.js';
import 'component/c005-flightstatus.js';
import 'component/c005-login.js';
import 'component/c005-cuglogin.js';
import 'component/c005-mhupgrade.js';
import 'component/c005-mobileBookingform.js';
import 'component/c005-stay.js';
import 'component/c005-viewbooking.js';
import 'component/c005-inflightMenu.js';
import 'component/c005-ibe-cta.js';
import 'component/c005-mholidays.js';
import 'component/c005-mobileMholidaysform.js';
import 'component/c005-milesCalculator.js';
import 'component/c005-plusgrade-nfs.js';
import 'component/c005-flight-shedule.js';
import 'component/c005-flight-upgrade.js';
import 'component/c005-flight-schedulepage.js'
import 'component/c006.js';
import 'component/c008.js';
import 'component/c009.js';
import 'component/c011.js';
import 'component/c012.js';
import 'component/c014-newsletterWidget.js';
import 'component/c015.js';
import 'component/c017.js';
import 'component/c018.js';
import 'component/c020.js';
import 'component/c021.js';
import 'component/c022.js';
import 'component/c023.js';
import 'component/c024.js';
import 'component/c025.js';
import 'component/c029.js';
import 'component/c033.js';
import 'component/c035.js';
import 'component/c038.js';
import 'component/c040.js';
import 'component/c041.js';
import 'component/c042.js';
import 'component/c043.js';
import 'component/c044.js';
import 'component/c048.js';
import 'component/c049.js';
import 'component/c049-searchform.js';
import 'component/c056.js';
import 'component/c058.js';
import 'component/c059.js';
import 'component/c060.js';
import 'component/c062.js';
import 'component/c063.js';
import 'component/c065.js';
import 'component/c066.js';
import 'component/c069.js';
import 'component/c070.js';
import 'component/c072.js';
import 'component/c077.js';
import 'component/c080.js';
import 'component/c081.js';
import 'component/c082.js';
import 'component/c083.js';
import 'component/c085.js';
import 'component/c086.js';
import 'component/c087.js';
import 'component/c089.js';
import 'component/c090.js';
import 'component/c091.js';
import 'component/c092.js';
import 'component/c094.js';
import 'component/c095.js';
import 'component/contact-form.js';
import 'component/cug-login.js';
import 'component/gst.js';
import 'component/member-portal.js';
import 'component/qrcode-game.js';

//Student portal files
import 'component/c100.js';
import 'component/c101.js';
import 'component/c103.js';

import 'component/c105.js';
import 'component/c106.js';
import 'component/c107.js';
import 'component/c109.js';
import 'component/c111.js';
import 'component/c110.js';
import 'component/feedback.js';
import 'component/enrich-mobilemenuLogout.js';
import 'component/c109-covidwaiver-form.js';
import 'component/c115.js';
import 'component/ibe-standalone-iframe.js';
import 'component/c117.js';
import 'component/rebate-mango.js';
import 'component/c120.js';
import 'component/qwikcilver--search-panel.js';
import 'component/c005-morelinks.js';
import 'component/home-slider.js';
import 'component/c121.js';
import 'component/enrich-partners.js';
import 'component/checkout.js';

//mh explorer
import 'component/mhexplorer/partners-carousel.js';
import 'component/mhexplorer/mobile-carousel.js';
import 'component/c122.js';
import 'component/c005-smartalerts.js';
import 'component/c005-enrich-hotels.js';
import 'component/c005-mobile-enrich-hotels.js';
import 'component/enrich-mobmenu.js';
import 'component/enrich-partners-table.js';
import 'component/voucher-campaign-table.js';
import 'component/activate-acc.js';
import 'component/timatic-widget.js';
import 'component/mhexplorer/signpost-section.js';
import 'component/mhexplorer/banner-section.js';
import 'component/timatic-column-control.js';
import 'component/mot-registration.js';
import 'component/adobeDataLayerMethod.js';

//enrich money
import 'component/enrichmoney/enrichmoney-header.js';
import 'component/enrichmoney/c007-card-carousel.js';